<template>
  <v-form ref="form">
    <div>
      <v-row>
        <v-col cols="12" class="mb-8">
          <h3 class="font-weight-bold black--text mb-4">Áreas cadastradas</h3>
          <v-data-table
            :headers="headerCafezal"
            :items="getArrayTable"
            no-data-text="Nenhuma área foi cadastrada"
            loading-text="Carregando Áreas..."
            :server-items-length="getArrayTable.length"
            class="area-table base__datatable"
            :footer-props="{
              'items-per-page-options': [25, 50, 100, 250, 500]
            }"
            :hide-default-footer="true"
            :item-class="affectRow"
          >
            <template v-slot:[`item.area`]="{ item }">
              {{
                getArrayTable.indexOf(item) != getArrayTable.length - 1
                  ? "Área " + (getArrayTable.indexOf(item) + 1)
                  : "TOTAL:"
              }}
            </template>
            <template v-slot:[`item.areaPlantada`]="{ item }">
              {{ asNumberString(item.areaPlantada) }}
            </template>
            <template v-slot:[`item.espacamentoPlantas`]="{ item }">
              {{
                getArrayTable.indexOf(item) != getArrayTable.length - 1
                  ? asNumberString(item.espacamentoPlantas)
                  : ""
              }}
            </template>
            <template v-slot:[`item.espacamentoLinhas`]="{ item }">
              {{
                getArrayTable.indexOf(item) != getArrayTable.length - 1
                  ? asNumberString(item.espacamentoLinhas)
                  : ""
              }}
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <v-row
                class="mt-1 mb-1 d-flex flex-row"
                v-if="getArrayTable.indexOf(item) != getArrayTable.length - 1"
              >
                <div class="d-inline-flex">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        ref="myDataTable"
                        color="secondary"
                        class="base-input-file__button mr-1 px-0"
                        @click="viewRow(item)"
                        v-on="on"
                      >
                        <v-icon size="14"> fa-regular fa-eye </v-icon>
                      </BaseButton>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        color="secondary"
                        class="base-input-file__button mr-1 px-0"
                        @click="editRow(item)"
                        v-on="on"
                      >
                        <v-icon size="12"> fas fa-pencil-alt </v-icon>
                      </BaseButton>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        color="secondary"
                        class="base-input-file__button mr-1 px-0"
                        @click="deleteRow(item)"
                        v-on="on"
                      >
                        <v-icon size="12"> fas fa-trash-alt </v-icon>
                      </BaseButton>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        color="secondary"
                        class="base-input-file__button mr-1 px-0"
                        title="Duplicar"
                        @click="duplicateRow(item)"
                        v-on="on"
                      >
                        <v-icon size="14"> fa-thin fa-copy </v-icon>
                      </BaseButton>
                    </template>
                    <span>Duplicar</span>
                  </v-tooltip>
                </div>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <ModalDeleteLineTable v-model="showDeleteModal" @close="closeModal" />
      <v-divider class="pb-6" />
      <v-row>
        <v-col cols="12" md="3" class="mb-xs-5 mb-sm-5" v-if="!enableArea">
          <BaseButton
            class="secondary text-uppercase subtitle-2 font-weight-bold"
            style="width: 100%"
            @click="addNewArea()"
          >
            <v-icon class="pr-4 add-icon">fa-plus</v-icon>
            ADICIONAR NOVA ÁREA
          </BaseButton>
        </v-col>
      </v-row>
      <v-row class="pb-12" v-if="enableArea">
        <v-col cols="12" sm="12" md="12" class="pr-0 pr-md-5">
          <h3 class="font-weight-bold black--text mb-4">Adicionar nova área</h3>
          <!-- Input de nome da area -->
          <BaseFormInput
            id-element="riskAreaName"
            placeholder="Nome da Área"
            v-model="newAreaItem.nome"
            label-text="Nome da Área"
            required
            :rules="[requiredInput]"
            :disabled="this.readOnlyState"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-sm-5">
          <!-- Select de especie do cafe -->
          <BaseFormSelect
            id-element="riskEspecie"
            placeholder="Selecione"
            label-text="Espécie"
            v-model="newAreaItem.especie"
            :items="cafezalEspecieOptions"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
            :disabled="this.readOnlyState"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-sm-5">
          <!-- Select de variedade do cafe -->
          <BaseFormSelect
            id-element="riskVariedade"
            placeholder="Selecione"
            v-model="newAreaItem.variedade"
            :items="cafezalVariedadeOptions"
            label-text="Variedade"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
            :disabled="this.readOnlyState"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-sm-5">
          <!-- Select de sistema de cultivo do cafe -->
          <BaseFormSelect
            id-element="riskSistemaCultivo"
            placeholder="Selecione"
            v-model="newAreaItem.sistemaCultivo"
            :items="cafezalSistemaCultivoOptions"
            label-text="Sistema de Cultivo"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
            :disabled="this.readOnlyState"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
          <!-- Input de tamanho da area -->
          <BaseMoney
            id-element="riskAreaSize"
            placeholder="0,00"
            v-model="newAreaItem.areaPlantada"
            label-text="Área Plantada (ha)"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :disabled="this.readOnlyState"
            :errorMessages="areaPlantadaErrorMessages"
            :v-on:change="validateAreaPlantada()"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
          <!-- Input de idade do cafe -->
          <BaseFormInput
            id-element="riskAge"
            placeholder="Digite"
            v-model="newAreaItem.idade"
            label-text="Idade da Planta (Anos)"
            type="number"
            required
            :rules="[requiredInput]"
            :disabled="this.readOnlyState"
          />
        </v-col>
        <v-col cols="12" sm="4" md="2" class="pr-0 pr-md-2">
          <!-- Input de data da ultima recepa -->
          <BaseFormInput
            id-element="dateLastReceive"
            v-model="newAreaItem.dataUltimaRecepa"
            placeholder="DD/MM/YYYY"
            required
            :rules="
              disabledDateLastReceive ? [] : [requiredInput, dateTermValid]
            "
            validate-on-blur
            v-facade="maskDate"
            label-text="Data da Última Recepa"
            :disabled="this.disabledDateLastReceive || this.readOnlyState"
          />
        </v-col>
        <v-col cols="12" sm="4" md="2" class="pr-0 pt-10">
          <v-checkbox
            v-model="naoHouveRecepa"
            label="Não houve"
            class="d-inline-block pr-5 ma-0 policy-table__checkbox pt-0"
            dense
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
          <!-- Input de espaçamento entre plantas -->
          <BaseMoney
            id-element="riskSpacingPlants"
            placeholder="0,00"
            v-model="newAreaItem.espacamentoPlantas"
            label-text="Espaçamento entre Plantas (m)"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :disabled="this.readOnlyState"
            :errorMessages="espacamentoPlantasErrorMessages"
            :v-on:change="validateEspacamentoPlantas()"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
          <!-- Input de espaçamento entre linhas de plantio -->
          <BaseMoney
            id-element="riskSpacingLines"
            placeholder="0,00"
            v-model="newAreaItem.espacamentoLinhas"
            label-text="Espaçamento entre Linhas (m)"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :disabled="this.readOnlyState"
            :errorMessages="espacamentoLinhasErrorMessages"
            :v-on:change="validateEspacamentoLinhas()"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
          <!-- Input readonly de plantas por hectare -->
          <p class="font-weight-bold primary--text text-center mb-0 mt-0">
            Plantas por Hectare
          </p>
          <h3 class="font-weight-bold primary--text mb-0 mt-3 text-center">
            {{ newAreaItem.plantasPorHectare }}
          </h3>
        </v-col>
        <v-col cols="12" class="pb-5 pt-8">
          <p class="font-weight-bold black--text quotation-title mb-1">
            Avaliação do Risco
          </p>
          <v-divider class="mb-2" />
          <!-- Switch se houve danos no ciclo -->
          <label for="switchdanosNoCiclo" class="mr-5"
            ><b
              >Há danos por granizo ou geada no ciclo agrícola atual?</b
            ></label
          >
          <v-switch
            class="pa-0 ma-0 justify-self-center d-inline-block"
            inset
            hide-details
            dense
            id="switchdanosNoCiclo"
            color="secondary"
            v-model="newAreaItem.danosNoCiclo"
            :disabled="this.readOnlyState"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ danosNoCicloText }}
          </p>
        </v-col>
      </v-row>
      <v-divider class="pb-6" v-if="enableArea" />
      <v-row v-if="enableArea">
        <QuotationKMLFile
          ref="quotationKMLFile"
          :areaItem="this.newAreaItem"
          :expectedMinAreaSize="getExpectedMinAreaSize"
          :expectedMaxAreaSize="getExpectedMaxAreaSize"
          class="col col-lg-12"
          :disabled="this.readOnlyState"
        />
      </v-row>
      <v-row v-if="enableArea">
        <v-col cols="2" class="mr-2">
          <BaseButton
            v-html="'Limpar'"
            class="secondary--text button-border"
            width="100%"
            outlined
            @click="clear()"
          />
        </v-col>
        <v-col cols="2">
          <BaseButton
            v-html="'Gravar Área'"
            class="white--text secondary"
            width="100%"
            @click="addRow()"
          />
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>
<script>
const money = {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  precision: 2,
  masked: false /* doesn't work with directive */
};

const headerCafezal = [
  { text: "Área", value: "area", sortable: false, width: "40px" },
  { text: "Nome", value: "nome", sortable: false, width: "50px" },
  {
    text: "Área Plantada",
    value: "areaPlantada",
    type: "number",
    sortable: false,
    width: "40px"
  },
  {
    text: "Variedade",
    value: "variedade.nome",
    sortable: false,
    width: "40px"
  },
  { text: "Idade", value: "idade", sortable: false, width: "40px" },
  {
    text: "Espaçamento Plantas",
    value: "espacamentoPlantas",
    type: "number",
    sortable: false,
    width: "40px"
  },
  {
    text: "Espaçamento Linhas",
    value: "espacamentoLinhas",
    type: "number",
    sortable: false,
    width: "40px"
  },
  {
    text: "Plantas/ Hectare",
    value: "plantasPorHectare",
    type: "number",
    sortable: false,
    width: "40px"
  },
  {
    text: "Últ. Recepa",
    value: "dataUltimaRecepa",
    sortable: false,
    width: "50px"
  },
  { text: "Ações", value: "id", sortable: false, width: "55px" }
];

const defaultItemCafezal = {
  id: null,
  key: 0,
  nome: null,
  areaPlantada: 0,
  especie: null,
  variedade: null,
  sistemaCultivo: null,
  idade: null,
  espacamentoPlantas: 0,
  espacamentoLinhas: 0,
  plantasPorHectare: 0,
  dataUltimaRecepa: null,
  danosNoCiclo: false,
  coordenadas: [],
  visible: true,
  kmlFiles: []
};

import { requiredInput, dateTermValid, aboveZero } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import BaseMoney from "../../../components/base/BaseMoney.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import QuotationKMLFile from "../components_agro/QuotationKMLFile.vue";
import ModalDeleteLineTable from "../components_agro/ModalDeleteLineTable.vue";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";

export default {
  name: "QuotationRiskItemCafezal",
  data: () => ({
    maskDate,
    asNumberString,
    formatExpirationDate,
    formatDDMMYYYYToIsoDate,
    requiredInput,
    dateTermValid,
    aboveZero,
    riskForm: null,
    typeDecimal: money,
    headerCafezal,
    disabledDateLastReceive: false,
    newAreaItem: null,
    editState: false,
    readOnlyState: false,
    nextId: 0,
    selectedRowToAffect: null,
    isAddingRow: false,
    areaPlantadaErrorMessages: [],
    espacamentoPlantasErrorMessages: [],
    espacamentoLinhasErrorMessages: [],
    enableArea: false,
    showDeleteModal: false,
    shouldDeleteData: false,
    totalAreaSize: 0,
    totalPlantas: 0,
    naoHouveRecepa: false
  }),
  props: {
    form: {
      type: Object
    }
  },
  async created() {
    this.initializeIdGenerator();
    this.newAreaItem = _.cloneDeep(defaultItemCafezal);
    this.newAreaItem.key = this.generateId();
    this.fetchCafezalOptions();
    this.naoHouveRecepa = (this.newAreaItem.dataUltimaRecepa == null);
  },
  components: {
    BaseMoney,
    QuotationKMLFile,
    ModalDeleteLineTable
  },
  mixins: [LoadingRequest],
  computed: {
    ...mapState("quotation", [
      "cafezalEspecieOptions",
      "cafezalVariedadeOptions",
      "cafezalSistemaCultivoOptions"
    ]),
    getArrayTable() {
      let arrayItensCafezal = [];
      if (this.form.cafezal.items.length > 0) {
        this.getTotal();
        arrayItensCafezal = [...this.form.cafezal.items];
        arrayItensCafezal.push({
          areaPlantada: this.totalAreaSize,
          plantasPorHectare: this.totalPlantas
        });
      }
      return arrayItensCafezal;
    },
    danosNoCicloText() {
      return this.newAreaItem.danosNoCiclo ? "SIM" : "NÃO";
    },
    getExpectedMinAreaSize() {
      return this.newAreaItem.areaPlantada * 0.9; // Por requisito foi definido 10% de tolerancia na variação da area plantada total
    },
    getExpectedMaxAreaSize() {
      return this.newAreaItem.areaPlantada * 1.1; // Por requisito foi definido 10% de tolerancia na variação da area plantada total
    },
    validForm() {
      return (
        this.$refs.form.validate() &&
        this.newAreaItem.nome != null &&
        this.newAreaItem.areaPlantada > 0 &&
        this.newAreaItem.especie != null &&
        this.newAreaItem.variedade != null &&
        this.newAreaItem.sistemaCultivo != null &&
        this.newAreaItem.idade != null &&
        this.newAreaItem.espacamentoPlantas > 0 &&
        this.newAreaItem.espacamentoLinhas > 0 &&
        (this.newAreaItem.dataUltimaRecepa != null || this.naoHouveRecepa)
      );
    }
  },
  methods: {
    ...mapActions(["showAlertNotification"]),
    ...mapActions("quotation", [
      "fetchCafezalEspecieOptions",
      "fetchCafezalVariedadeOptions",
      "fetchCafezalSistemaCultivoOptions"
    ]),
    getTotal() {
      this.totalAreaSize = 0;
      this.totalPlantas = 0;
      if (this.form.cafezal.items.length > 0) {
        for (let i = 0; i < this.form.cafezal.items.length; i++) {
          this.totalAreaSize += this.form.cafezal.items[i].areaPlantada;
          this.totalPlantas += this.form.cafezal.items[i].plantasPorHectare;
        }
      }
    },
    initializeIdGenerator() {
      for (let i = 0; i < this.form.cafezal.items.length; i++) {
        let item = this.form.cafezal.items[i];
        if (this.nextId < item.key) {
          this.nextId = item.key + 1;
        }
      }
    },
    focusDataTable() {
      setTimeout(() => {
        this.$refs.myDataTable.$el.focus();
      }, 200);
    },
    focusForm() {
      setTimeout(() => {
        document.getElementById("riskAreaName").focus();
      }, 200);
    },
    generateId() {
      this.nextId++;
      return this.nextId - 1;
    },
    async fetchCafezalOptions() {
      await this.withLoading(
        Promise.all([
          this.fetchCafezalEspecieOptions(),
          this.fetchCafezalVariedadeOptions(),
          this.fetchCafezalSistemaCultivoOptions()
        ])
      );
    },
    calculatePlantDensity() {
      let plantSpacing = this.newAreaItem.espacamentoPlantas ?? 0;
      let lineSpacing = this.newAreaItem.espacamentoLinhas ?? 0;

      let plantArea = plantSpacing * lineSpacing;

      if (plantArea > 0) {
        this.newAreaItem.plantasPorHectare = Math.round(10000 / plantArea);
      }
    },
    validateAreaPlantada() {
      if (
        this.newAreaItem.areaPlantada > 0 &&
        this.areaPlantadaErrorMessages.length != 0
      ) {
        this.areaPlantadaErrorMessages = [];
      }
    },
    validateEspacamentoPlantas() {
      if (
        this.newAreaItem.espacamentoPlantas > 0 &&
        this.espacamentoPlantasErrorMessages.length != 0
      ) {
        this.espacamentoPlantasErrorMessages = [];
      }
    },
    validateEspacamentoLinhas() {
      if (
        this.newAreaItem.espacamentoLinhas > 0 &&
        this.espacamentoLinhasErrorMessages.length != 0
      ) {
        this.espacamentoLinhasErrorMessages = [];
      }
    },
    validateInputBaseMoney() {
      if (
        !this.newAreaItem.areaPlantada > 0 &&
        this.areaPlantadaErrorMessages.length == 0
      ) {
        this.areaPlantadaErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newAreaItem.espacamentoPlantas > 0 &&
        this.espacamentoPlantasErrorMessages.length == 0
      )
        this.espacamentoPlantasErrorMessages.push("Este campo é obrigatório");

      if (
        !this.newAreaItem.espacamentoLinhas > 0 &&
        this.espacamentoLinhasErrorMessages.length == 0
      )
        this.espacamentoLinhasErrorMessages.push("Este campo é obrigatório");
    },
    addNewArea() {
      this.editState = false;
      this.enableArea = true;
      this.focusForm();
    },
    addRow() {
      this.newAreaItem.coordenadas = this.$refs.quotationKMLFile.getCoordinates();
      if (!this.validForm) {
        this.validateInputBaseMoney();

        this.showAlertNotification({
          message: "Preencha todos os campos corretamente antes de prosseguir.",
          type: "error"
        });
        return;
      }

      if (!this.editState) {
        this.newAreaItem.key = this.generateId();
        this.form.cafezal.items.push(_.cloneDeep(this.newAreaItem));
      } else {
        let index = this.form.cafezal.items.findIndex(
          x => x.key == this.newAreaItem.key && x.id == this.newAreaItem.id
        );
        this.form.cafezal.items[index] = _.cloneDeep(this.newAreaItem);
        // força atribuição no array p/ o vue detectar a alteração e deixar reativo
        this.form.cafezal.items = this.form.cafezal.items.slice();
      }

      this.getTotal();
      this.limparInput();
      this.focusDataTable();
      this.showAlertNotification({
        message: "Área incluída com sucesso.",
        type: "success"
      });

      this.enableArea = false;
      return;
    },
    limparInput() {
      this.newAreaItem = _.cloneDeep(defaultItemCafezal);
      this.$refs.form.reset();
      this.areaPlantadaErrorMessages = [];
      this.espacamentoPlantasErrorMessages = [];
      this.espacamentoLinhasErrorMessages = [];
    },
    viewRow(item) {
      this.enableArea = true;
      this.readOnlyState = true;
      this.editState = false;
      this.newAreaItem = _.cloneDeep(item);
      this.isAddingRow = false;
      this.selectedRowToAffect = this.form.cafezal.items.indexOf(item);
      this.formFocusTable();
    },
    editRow(item) {
      this.enableArea = true;
      this.readOnlyState = false;
      this.editState = true;
      this.newAreaItem = _.cloneDeep(item);
      this.isAddingRow = false;
      this.selectedRowToAffect = this.form.cafezal.items.indexOf(item);
      if (this.newAreaItem.key == null) {
        let key = this.generateId();
        this.form.cafezal.items[this.selectedRowToAffect].key = key;
        this.newAreaItem.key = key;
      }
    },
    closeModal(valor) {
      this.shouldDeleteData = valor;
      this.showDeleteModal = false;
      this.$emit("modal-closed");
    },
    deleteRow(item) {
      this.showDeleteModal = true;

      this.$once("modal-closed", () => {
        if (this.shouldDeleteData) {
          this.isAddingRow = false;
          this.selectedRowToAffect = null;
          this.form.cafezal.items = this.form.cafezal.items.filter(
            x => x != item
          );
          this.getTotal();
        }
      });
    },
    duplicateRow(item) {
      this.newAreaItem = _.cloneDeep(item);
      this.newAreaItem.key = this.generateId();
      this.newAreaItem.id = null;
      this.newAreaItem.coordenadas = [];
      this.newAreaItem.kmlFiles = [];
      this.form.cafezal.items.push(_.cloneDeep(this.newAreaItem));
      this.editState = true;
      this.readOnlyState = false;
      this.isAddingRow = true;
      this.selectedRowToAffect = null;
      this.getTotal();
    },
    clear() {
      this.limparInput();
      this.enableArea = false;
      this.editState = false;
      this.readOnlyState = false;
      this.selectedRowToAffect = null;
    },
    affectRow(item) {
      let selectedRow = this.form.cafezal.items.indexOf(item);
      let itemClass = "";

      if (this.isAddingRow) {
        itemClass = "table-row";
      }

      if (this.selectedRowToAffect === selectedRow) {
        itemClass += "selected-row";
      }

      //TODO: Alterar a linha para negrito quando for o total
      //itemClass = item.area == 'TOTAL:' ? "row-total" : "";

      return itemClass;
    }
  },
  watch: {
    "newAreaItem.espacamentoPlantas": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.espacamentoPlantas == oldValue?.espacamentoPlantas
      )
        return this.calculatePlantDensity();
    },
    "newAreaItem.espacamentoLinhas": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.espacamentoLinhas == oldValue?.espacamentoLinhas
      )
        return this.calculatePlantDensity();
    },
    "newAreaItem.dataUltimaRecepa": function(newVal) {
      this.naoHouveRecepa = !(newVal != null && newVal != "");
    },
    "naoHouveRecepa": function(newVal) {
      if (newVal) {
        this.newAreaItem.dataUltimaRecepa = null;
        this.disabledDateLastReceive = true;
      } else {
        this.disabledDateLastReceive = false;
      }
    }
  }
};
</script>
<style scoped lang="sass">
.row-total
  font-weight: bold
</style>
